/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Formatfocushint2Inputs */

const en_formatfocushint2 = /** @type {(inputs: Formatfocushint2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`The AI shows it larger and gives the rest less room. Leave it empty to keep everything in view.`)
};

const de_formatfocushint2 = /** @type {(inputs: Formatfocushint2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Die KI zeigt das größer und gibt dem Rest weniger Platz. Leer lassen, dann bleibt alles sichtbar.`)
};

/**
* | output |
* | --- |
* | "The AI shows it larger and gives the rest less room. Leave it empty to keep everything in view." |
*
* @param {Formatfocushint2Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const formatfocushint2 = /** @type {((inputs?: Formatfocushint2Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Formatfocushint2Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_formatfocushint2(inputs)
	return de_formatfocushint2(inputs)
});
export { formatfocushint2 as "formatFocusHint" }